import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, ArrowUpRight } from "lucide-react";
import Logo from "./Logo";
import { company, footerLinks } from "../mock";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#08080a] relative">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Logo />
            <p className="mt-6 text-stone-400 text-sm leading-relaxed max-w-sm">
              Institutional discipline for private capital. Insurance, investing, and
              property management — stewarded as a single balance sheet.
            </p>
            <p className="mt-6 eyebrow">{company.tagline}</p>
          </div>

          {footerLinks.map((col) => (
            <div key={col.heading} className="lg:col-span-2">
              <h4 className="font-mono-l text-[11px] tracking-[0.2em] uppercase text-stone-500 mb-5">
                {col.heading}
              </h4>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.path}>
                    <Link
                      to={l.path}
                      className="text-stone-300 hover:text-[#c8a951] text-sm transition-colors hover-line"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-3">
            <h4 className="font-mono-l text-[11px] tracking-[0.2em] uppercase text-stone-500 mb-5">
              Contact
            </h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3 text-stone-300">
                <MapPin className="w-4 h-4 text-[#c8a951] mt-0.5 shrink-0" />
                <span>{company.contact.address}</span>
              </li>
              <li>
                <a href={`tel:${company.contact.phone}`} className="flex items-center gap-3 text-stone-300 hover:text-[#c8a951] transition-colors">
                  <Phone className="w-4 h-4 text-[#c8a951] shrink-0" />
                  {company.contact.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${company.contact.email}`} className="flex items-center gap-3 text-stone-300 hover:text-[#c8a951] transition-colors break-all">
                  <Mail className="w-4 h-4 text-[#c8a951] shrink-0" />
                  {company.contact.email}
                </a>
              </li>
            </ul>
            <Link
              to="/contact"
              className="mt-6 inline-flex items-center gap-1.5 text-[#c8a951] text-sm font-medium hover-line"
            >
              Start a conversation <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
          <p className="text-stone-500 text-xs font-mono-l">
            © {new Date().getFullYear()} {company.legal}. All rights reserved.
          </p>
          <p className="text-stone-600 text-xs font-mono-l">
            Principal · {company.contact.principal}
          </p>
        </div>
      </div>
    </footer>
  );
}
